// Copy-Paste Ready Code for Theme Integration

/**
 * Formats a given amount into the active currency format.
 * @param {string|number} amount - The amount to format.
 * @returns {string} - The formatted currency string.
 */
function moneyFormat(amount) {
  if (amount === null || amount === undefined || amount === '') return '';
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'USD';

  let dollars = 0;
  if (typeof amount === 'string') {
    const num = parseFloat(amount.replace(/[^0-9.-]+/g, '')) || 0;
    if (amount.indexOf('.') !== -1) {
      dollars = num;
    } else {
      dollars = num > 1000 ? (num / 100) : num;
    }
  } else if (typeof amount === 'number') {
    dollars = amount > 1000 ? (amount / 100) : amount;
  } else {
    const num = Number(amount) || 0;
    dollars = num > 1000 ? (num / 100) : num;
  }

  return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(dollars);
}

/**
 * Sanitizes a URL to prevent XSS vulnerabilities.
 * @param {string} u - The URL to sanitize.
 * @returns {string} - The sanitized URL.
 */
function sanitizeUrl(u) {
  try {
    if (!u) return '#';
    const s = String(u).trim();
    if (s.indexOf('/') === 0) return s; // relative path
    if (/^(https?:)?\/\//i.test(s)) return s; // absolute or protocol-relative
    return '#';
  } catch (e) {
    return '#';
  }
}